<section class="editOrder w-full max-w-3xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <!-- Page header -->
  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">עריכת הזמנה</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ userName || 'הזמנה' }}</h1>
    <p class="text-sm text-ink-500" *ngIf="doneBy || createdAt">
      <ng-container *ngIf="doneBy">נעשה ע"י <span class="font-semibold">{{ doneBy }}</span></ng-container>
      <ng-container *ngIf="createdAt"> &middot; {{ createdAt }}</ng-container>
    </p>
    <p class="text-sm text-danger font-medium" *ngIf="updatedAt">
      <i class="material-symbols-outlined text-base align-middle" aria-hidden="true">history</i>
      עודכן לאחרונה ב-{{ updatedAt }}
    </p>
  </header>

  <!-- Form -->
  <form
    [formGroup]="orderForm"
    (ngSubmit)="save()"
    class="card-2026 space-y-5"
    novalidate
    autocomplete="off"
  >

    <!-- Items purchased -->
    <div class="form-row-2026">
      <label class="form-row-2026__label">מה נרכש</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>פרטי הזמנה (אפשר כמה)</mat-label>
        <mat-select formControlName="name" multiple>
          <mat-option *ngFor="let item of names" [value]="item.value">
            {{ item.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Parasha / Holiday -->
    <div class="form-row-2026">
      <label class="form-row-2026__label" for="editOrderParasha">פרשה או חג</label>
      <mat-form-field appearance="outline" class="w-full">
        <input
          id="editOrderParasha"
          matInput
          placeholder="חפש פרשה או חג..."
          [formControl]="parashaFilterCtrl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          class="parasha-autocomplete-panel"
        >
          <mat-optgroup label="פרשות השבוע">
            <mat-option
              *ngFor="let p of filteredParashotOptions | async"
              [value]="p"
              (onSelectionChange)="selectOption(p)"
            >
              {{ p.heb }}
            </mat-option>
            <mat-option *ngIf="(filteredParashotOptions | async)?.length === 0" disabled>
              לא נמצאה פרשה
            </mat-option>
          </mat-optgroup>
          <mat-optgroup label="חגים ומועדים">
            <mat-option
              *ngFor="let h of filteredHolidaysOptions | async"
              [value]="h"
              (onSelectionChange)="selectOption(h)"
            >
              {{ h.heb }} ({{ h.eng }})
            </mat-option>
            <mat-option *ngIf="(filteredHolidaysOptions | async)?.length === 0" disabled>
              לא נמצא חג
            </mat-option>
          </mat-optgroup>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Money fields side by side on desktop -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-row-2026" *ngIf="orderForm.get('name')?.value != 'זיכוי'">
        <app-money-input
          formControlName="price"
          label="עלות (₪)"
        ></app-money-input>
      </div>
      <div class="form-row-2026">
        <app-money-input
          formControlName="pricePaid"
          [label]="(orderForm.get('name')?.value === 'זיכוי' ? 'סכום' : 'שולם') + ' (₪)'"
        ></app-money-input>
      </div>
    </div>

    <!-- Invoice + pre-balance side by side -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-row-2026">
        <label class="form-row-2026__label" for="editOrderInvoice">מס' קבלה</label>
        <input
          id="editOrderInvoice"
          type="text"
          placeholder="ABC-1001"
          class="input-2026"
          formControlName="orderInvoice"
        />
      </div>
      <div class="form-row-2026">
        <app-money-input
          formControlName="current_balance"
          label="יתרה לפני הפעולה (₪)"
          [allowNegative]="true"
        ></app-money-input>
        <small class="form-row-2026__hint">ערך לצפייה בלבד &mdash; היתרה לפני שההזמנה הזו הוזנה.</small>
      </div>
    </div>

    <!-- Actions row -->
    <div class="pt-3 border-t border-ink-100 flex flex-col md:flex-row md:justify-between gap-3">
      <!-- Left side: cancel + delete -->
      <div class="flex flex-col md:flex-row gap-3">
        <button
          type="button"
          class="btn-2026--ghost w-full md:w-auto"
          (click)="cancel()"
        >
          <span class="material-symbols-outlined scale-x-[-1]" aria-hidden="true">arrow_back</span>
          ביטול / חזרה
        </button>
        <button
          type="button"
          class="btn-2026--danger w-full md:w-auto"
          (click)="openDeleteModal()"
        >
          <i class="material-symbols-outlined" aria-hidden="true">delete</i>
          מחיקת הזמנה
        </button>
        <app-confirm-dialog
          #confirmDialog
          [action]="deleteAction"
          [loading]="loading"
        ></app-confirm-dialog>
      </div>

      <!-- Right side: save (only when dirty) -->
      <button
        *ngIf="orderForm.dirty"
        type="submit"
        class="btn-2026--primary w-full md:w-auto md:min-w-[180px]"
        [disabled]="orderForm.invalid || loading"
      >
        <span *ngIf="!loading" class="flex items-center gap-2">
          <i class="material-symbols-outlined" aria-hidden="true">save</i>
          שמור שינויים
        </span>
        <span *ngIf="loading" class="flex items-center gap-2">
          <mat-spinner diameter="22"></mat-spinner>
          <span>שומר...</span>
        </span>
      </button>
    </div>

  </form>
</section>

<style>
  .parasha-autocomplete-panel .mat-autocomplete-panel {
    max-height: 250px !important;
    overflow-y: auto;
  }
</style>
